import React from 'react';
import { Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * File Retention (#2749/#2752): shown on a request whose files were deleted.
 * The record itself stays readable: brief, versions list and comments.
 */
const RequestFilesDeletedBanner: React.FC = () => {
  const { t } = useTranslation();

  // The date sits in the status line next to the pill; the banner explains what's kept.
  return (
    <div
      className={
        'tw-mb-3 tw-flex tw-items-start tw-gap-2 tw-rounded-md tw-bg-neutral-100 tw-p-3 tw-text-sm tw-text-text-subtle'
      }
      role={'status'}
    >
      <Trash2 size={16} className={'tw-mt-0.5 tw-shrink-0'} aria-hidden={'true'} />
      <span>
        {t('request_files_were_deleted', {
          defaultValue:
            "This request's files were deleted. The request brief, versions and comments are kept here.",
        })}
      </span>
    </div>
  );
};

export { RequestFilesDeletedBanner };
